import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { Options } from 'react-scan'

export interface ReactScanState {
  enabled: boolean
}

export interface DebugState {
  reactScan: Options
}

const initialDebugState: DebugState = {
  reactScan: { enabled: false },
}

export const debugSlice = createSlice({
  name: 'debug',
  initialState: initialDebugState,
  reducers: {
    configureReactScan: (state, payload: PayloadAction<Options>) => {
      state.reactScan = payload.payload
    },
  },
})

export const { configureReactScan } = debugSlice.actions
export const debugActions = debugSlice.actions
